import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from "../../box/src";
import { linkEffect, linkHoverEffect } from "../../theme/src";
export const BreadcrumbItem = ({ font, tab, useLinkEffectOnHoverOnly, }) => {
    const { active = false, dataTestId, disable = false, label, onClickAction, } = tab;
    const commonProps = {
        dataTestId,
        font,
    };
    if (disable) {
        return (_jsx(Box, Object.assign({}, commonProps, { opacity: 0.6, children: label })));
    }
    if (active || !onClickAction) {
        return _jsx(Box, Object.assign({}, commonProps, { children: label }));
    }
    return (_jsx(ClickableTab, Object.assign({}, commonProps, { "$linkHoverEffect": useLinkEffectOnHoverOnly, as: "a", onClick: onClickAction, tabIndex: 0, children: label })));
};
const ClickableTab = styled(Box) `
  ${({ $linkHoverEffect }) => $linkHoverEffect ? linkHoverEffect() : linkEffect()}
`;
//# sourceMappingURL=BreadcrumbItem.js.map